/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_Efforts_Detect_Threshold_PaceInputs */

const en_ui_laps_efforts_detect_threshold_pace = /** @type {(inputs: Ui_Laps_Efforts_Detect_Threshold_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add threshold pace to detect efforts`)
};

const de_ui_laps_efforts_detect_threshold_pace = /** @type {(inputs: Ui_Laps_Efforts_Detect_Threshold_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwellentempo eintragen zum Erkennen`)
};

/**
* | output |
* | --- |
* | "Add threshold pace to detect efforts" |
*
* @param {Ui_Laps_Efforts_Detect_Threshold_PaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_efforts_detect_threshold_pace = /** @type {((inputs?: Ui_Laps_Efforts_Detect_Threshold_PaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Efforts_Detect_Threshold_PaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_efforts_detect_threshold_pace(inputs)
	return de_ui_laps_efforts_detect_threshold_pace(inputs)
});